import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum SimpleRating {
    GOOD = 1,
    NEUTRAL = 0,
    BAD = -1,
}

export namespace SimpleRating {
    type Data = {
        text: string;
        icon: string;
        color: string;
    }

    export const Record: Record<SimpleRating, Data> = {
        [SimpleRating.GOOD]: {
            text: 'Gut',
            icon: 'mdi-emoticon-happy',
            color: 'success',
        },
        [SimpleRating.NEUTRAL]: {
            text: 'Neutral',
            icon: 'mdi-emoticon-neutral',
            color: 'warning',
        },
        [SimpleRating.BAD]: {
            text: 'Schlecht',
            icon: 'mdi-emoticon-sad',
            color: 'error',
        },
    }

    export const Items = mapRecordToItems(Record);
    Items.sort((a, b) => (a.value as number) - (b.value as number));
}
